import styles from '../styles/Spinner.module.css'

const Spinner = (props) => {
  const {darktheme, align, isInline, labelType } = props

  //build className based on props
  const getClassName = () => {
    let className = styles.spinnerContainer
    if (props.children) className += ` ${styles.addText}`
    if (darktheme) className += ` ${styles.darkTheme}`
    if (props.window) className += ` ${styles.fixedWindow}`
    if (align) className += ` ${styles[align]}`
    if (isInline) className += ` ${styles.inline}`
    if (labelType === 'inline') className += ` ${styles.inlineLabel}`

    return className
  }

  return ((props.style) ? (
    <div className={getClassName()} style={props.style}>
      <div className={styles.spinner}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <label>{props.children}</label>
    </div>
    ) : (
    <div className={getClassName()}>
      <div className={styles.spinner}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <label>{props.children}</label>
    </div>
    )

  )
}

export default Spinner;